import React, { memo } from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import line from "../../assents/img/Line.png";

import AddStopButton from "../AddStopButton";
import AddStopModal from "../Modals/AddStopModal";

const Wrapper = styled(Box)(({ theme, notmobile }) => ({
  width: "335px",
  paddingBottom: "54px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: notmobile ? "0px 0px 10px rgba(0, 0, 0, 0.15)" : "",
  [theme.breakpoints.up("sm")]: {
    width: "100%",
    paddingBottom: "29px",
    margin: 0,
    position: "sticky",
    bottom: 0,
    backgroundColor: "inherit",
  },
}));

const Line = styled(Box)(({ theme }) => ({
  height: "31px",
  width: "100%",
  backgroundImage: `url(${line})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  [theme.breakpoints.up("sm")]: {
    height: "35px",
  },
}));

const AddStopSections = memo(
  ({
    stops,
    addedStopsId,
    total,
    tourDefaultPrice,
    addStation,
    open,
    handleCloseModal,
    handleOpenModal,
    isMobile,
  }) => {
    return (
      <>
        <Wrapper notmobile={isMobile ? "" : "true"}>
          <Line />
          <AddStopButton handleClick={handleOpenModal} />
        </Wrapper>
        <AddStopModal
          stops={stops}
          addedStopsId={addedStopsId}
          total={total}
          tourDefaultPrice={tourDefaultPrice}
          addStation={addStation}
          open={open}
          handleClose={handleCloseModal}
        />
      </>
    );
  }
);

export default AddStopSections;
